<template>
  <div class="clearfix">
    <div class="main-content clearfix">
      <div class="row">
        <div class="col-xs-12 table-filter">
          <div class="row p-b-sm">
            <div class="col-sm-6 col-xs-12">
              <h4 class="table-name">测评邀请</h4>
            </div>
            <div class="col-xs-12 col-sm-6 right">
              <button type="button" class="btn btn-sm btn-primary right" @click="add()">发送邀请 </button>
              <button type="button" class="btn btn-sm btn-primary right m-r-sm upload-btn" id="upload-resume-btn">导入简历</button>
              <a href="/assets/tpls/resume-tpl.xlsx" download="resume.xlsx" target="_blank" class="btn btn-sm btn-primary right m-r-sm">下载模板</a>
              <button type="button" class="btn btn-sm btn-primary right m-r-sm" @click="batchInvites()">批量邀请</button>
            </div>
          </div>

          <div class="row m-b-sm">
            <div class="col-xs-12">
              <span class="bold">所在部门：</span>
              <select v-model="parent.selected" class="select input-sm m-r-xs" @change="selectParent($event,indexd)" v-for="(parent,indexd) in filter.pids" :key="indexd">>
                <option :value="p._id" v-for="p in parent.options" :key="p._id">{{p.name}}</option>
              </select>
            </div>
          </div>
          <div class="row m-b-sm">
            <div class="col-sm-6 col-xs-12">
              <span class="bold">测评岗位：</span>
              <select v-model.trim="filter.questionnaire_post" class="input-sm">
                <option value="-1">全部岗位</option>
                <option :value="post._id" v-for="post in posts" :key="post._id">{{post.name}}</option>
              </select>
            </div>
            <div class="col-xs-12 col-sm-6">
              <span class="bold">就职状态：</span>
              <input type="radio" name="tag" value="0" v-model.number="filter.tag" id="tag-all">
              <label for="tag-all">全部</label>
              <input type="radio" name="tag" value="1" v-model.number="filter.tag" id="tag-finish">
              <label for="tag-finish">未入职</label>
              <input type="radio" name="tag" value="2" v-model.number="filter.tag" id="tag-send">
              <label for="tag-send">入职</label>
              <input type="radio" name="tag" value="3" v-model.number="filter.tag" id="tag-send">
              <label for="tag-send">不考虑</label>
            </div>
          </div>
          <div class="row p-b-sm">
            <div class=" col-xs-12 col-sm-8">
              <div class="row">
                <div class="col-xs-12 col-sm-9">
                  <span class="bold">邀请状态：</span>
                  <input type="radio" name="status" value="0" v-model.number="filter.status" id="status-all">
                  <label for="status-all">全部</label>
                  <input type="radio" name="status" value="3" v-model.number="filter.status" id="status-finish">
                  <label for="status-finish">已测评</label>
                  <input type="radio" name="status" value="2" v-model.number="filter.status" id="status-send">
                  <label for="status-send">已发送</label>
                  <input type="radio" name="status" value="1" v-model.number="filter.status" id="status-new">
                  <label for="status-new">未发送</label>
                  <input type="radio" name="status" value="-2" v-model.number="filter.status" id="status-effective">
                  <label for="status-new">已过期</label>
                </div>
                <div class="col-xs-12 col-sm-3" v-if="user.category===2">
                  <input type="checkbox" :true-value="1" :false-value="0" v-model.number="filter.isMy" id="status-new">
                  <label for="status-new">只看我的</label>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4">
              <div class="row">
                <div class="col-sm-9 col-xs-12 n-p-r">
                  <input type="text" class="input input-sm" placeholder="输入姓名、手机号进行搜索" required="required" v-model.trim="filter.search" autocomplete="off" @keyup.enter="reload()">
                </div>
                <div class="col-sm-3 col-xs-12">
                  <button type="button" class="btn btn-sm btn-primary col-xs-12" @click="reload()">搜索</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <loading v-if="loading === 1" class="col-xs-12"></loading>
        <div class="col-xs-12" v-show="loading === 0">
          <table class="table table-border">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" v-model="select_all" v-bind:true-value="1" v-bind:false-value="0" @click="toggleSelectAll()">
                </th>
                <th>姓名</th>
                <th>联系方式</th>
                <th>部门</th>
                <th v-show="filter.questionnaire_post === '-1'">岗位</th>
                <th>综合得分</th>
                <th>邀请时间</th>
                <th>测评时间</th>
                <th v-if="user.category === 2 && filter.isMy ===0">HR</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="invitation in invitations" :key="invitation._id">
                <td>
                  <input type="checkbox" :disabled="invitation.status !== 1 && invitation.status !== -2 " v-model="invitation.selected" v-bind:true-value="1" v-bind:false-value="0" @click="toggleSelectNode(invitation)">
                </td>
                <td>
                  <router-link :to="{'name': 'EvaluateReport',params: {'code': invitation.evaluate_record.record ||'undefined'}}" class="color-primary bold" v-if="invitation.status === 3" target="_blank" title="点击查看报告">{{invitation.realname}}</router-link>
                  <span v-if="invitation.status !== 3">{{invitation.realname}}</span>
                  <span v-if="invitation.status === 3" class="badge" :class="{'bg-success': invitation.tag === 2,'bg-warning': invitation.tag === 3}">{{invitation.tag === 1 ? '未入职':(invitation.tag === 2 ? '入职':'不考虑')}}</span>
                </td>
                <td>{{invitation.phone||invitation.email}}</td>
                <td>{{invitation.organization ? invitation.organization.name:'-'}}</td>
                <td v-show="filter.questionnaire_post === '-1'">{{invitation.questionnaire_post&&(invitation.questionnaire_post.name)}}</td>
                <td v-if="invitation.status === 3">{{invitation.score.toFixed(2)}}</td>
                <td v-if="invitation.status !== 3">-</td>
                <td v-if="invitation.status >= 2">{{invitation.evaluate_record.invitate_time|format('YYYY-MM-DD',invitation.evaluate_record.invitate_time)}}</td>
                <td v-if="invitation.status < 2">-</td>
                <td v-if="invitation.status === 3">{{invitation.complete_at|format('YYYY-MM-DD',invitation.complete_at)}}</td>
                <td v-if="invitation.status !== 3">-</td>
                <td v-if="user.category === 2 && filter.isMy === 0 ">
                  {{invitation.owner?(invitation.owner.realname||'-'):'管理员'}}
                </td>
                <td>
                  <span class="btn btn-primary btn-xs" @click="show(invitation)">查看</span>
                  <span class="btn  btn-danger btn-xs" v-if="invitation.status === 1 || invitation.status === -2" @click="invite(invitation)">邀请</span>
                  <a :href="invitation.resume.is_convert === -1 ?invitation.resume.url :invitation.resume.url_convert " class="btn btn-warning btn-xs" v-if="invitation.status === 3 && invitation.resume" target="_blank">简历</a>
                  <router-link :to="{'name': 'EvaluateReport',params: {'code': invitation.evaluate_record.record||'undefined'}}" class="btn  btn-info btn-xs" v-if="invitation.status === 3" target="_blank">报告</router-link>
                  <span v-if="invitation.status === 3 && invitation.tag === 1" class="btn btn-xs btn-xs btn-success" @click="tagInivite(invitation)">标记</span>
                  <span v-if="invitation.status === 3 && (selectPost === '-1' || selectPost=== invitation.questionnaire_post._id )" class="btn btn-xs btn-xs" @click="addCompareResume(invitation)">对比</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-xs-12" v-show="loading === 0">
          <pagination :current="filter.current" :length="filter.length" :total="filter.total" :page-click="go"></pagination>
        </div>
      </div>
    </div>
    <!-- edit -->
    <div v-if="modal.edit">
      <div class="overlay">
      </div>
      <transition name="fade">

        <div class="modal">
          <div class="modal-header">
            {{modal.title}}
            <span class="close" @click="clearEdit()">X</span>
          </div>
          <div class="modal-body w-sm">
            <form action="">
              <div class="form-group">
                <div class="row">
                  <div class="col-xs-4 text-right label p-t-b-sm n-p-r">
                    姓名:
                  </div>
                  <div class="col-xs-4">
                    <input type="text" class="input input-md" v-model.trim="invitation.realname" placeholder="姓名:风清扬" :readonly="modal.readonly">
                  </div>
                  <div class="col-xs-4 label p-t-b-sm n-p-l text-left">
                    *
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-xs-4 text-right label p-t-b-sm n-p-r">
                    邮箱:
                  </div>
                  <div class="col-xs-4">
                    <input type="text" class="input input-md" v-model.trim="invitation.email" placeholder="邮箱:test@test.com" :readonly="modal.readonly">
                  </div>
                  <div class="col-xs-4 label p-t-b-sm n-p-l text-left">
                    *
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-xs-4 text-right label p-t-b-sm n-p-r">
                    手机号:
                  </div>
                  <div class="col-xs-4">
                    <input type="text" class="input input-md" v-model.trim="invitation.phone" placeholder="手机号:18888888888" :readonly="modal.readonly">
                  </div>
                  <div class="col-xs-4 label p-t-b-sm n-p-l text-left">
                    *
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-xs-4 text-right label p-t-b-sm n-p-r">
                    岗位:
                  </div>
                  <div class="col-xs-4">
                    <select v-model.trim="invitation.questionnaire_post" class="input-md col-xs-12" :disabled="invitation._id">
                      <option value="-1">全部岗位</option>
                      <option :value="post._id" v-for="post in posts" :key="post._id">{{post.name}}</option>
                    </select>
                  </div>
                  <div class="col-xs-4 label p-t-b-sm n-p-l text-left">
                    *
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-xs-4 text-right label p-t-b-sm n-p-r">
                    所在部门（院系）:
                  </div>
                  <div class="col-xs-4 clearfix">
                    <select v-model="parent.selected" class="select input-md col-xs-12 m-b-sm" @change="selectIParent($event,indexd)" v-for="(parent,indexd) in invitation.pids" :key="indexd" :disabled="modal.readonly">
                      <option :value="p._id" v-for="p in parent.options" :key="p._id">{{p.name}}</option>
                    </select>
                  </div>
                  <div class="col-xs-4 label p-t-b-sm n-p-l text-left">
                  </div>
                </div>
              </div>
              <div class="form-group text-center">
                <div class="btn btn-primary m-r-md" @click="upsert()" v-if="!modal.readonly">发送邀请</div>
                <div class="btn btn-default" @click="clearEdit()" v-if="!modal.readonly">取消</div>
                <div class="btn btn-primary" @click="clearEdit()" v-if="modal.readonly">返回</div>
              </div>
            </form>
          </div>
        </div>
      </transition>
    </div>
    <!-- /edit end -->
    <!-- import -->
    <div v-if="modal.import">
      <div class="overlay">
      </div>
      <transition name="fade">
        <div class="modal">
          <div class="modal-header">
            {{modal.title}}
            <span class="close" @click="clearImport()">X</span>
          </div>
          <div class="modal-body w-sm" style="min-height:300px;">
            <div class="row">
              <div class="col-xs-12" style="max-height: 300px; overflow-y:scroll;">
                <table class="table table-border">
                  <thead>
                    <tr>
                      <th>序号</th>
                      <th>姓名</th>
                      <th>邮箱</th>
                      <th>手机号</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(invitation,ind) in import_invitations" :key="invitation.email">
                      <td>{{ind+1}}</td>
                      <td>{{invitation.realname}}</td>
                      <td>{{invitation.email}}</td>
                      <td>{{invitation.phone}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row m-t-sm">
              <div class="col-xs-12">
                <div class="col-xs-6 p-t-b-sm col-sm-3 text-right">
                  岗位:
                </div>
                <div class="col-xs-6 clearfix col-sm-5">
                  <select v-model.trim="import_questionnaire_post" class="input-md col-xs-12" :disabled="invitation._id">
                    <option value="-1">全部岗位</option>
                    <option :value="post._id" v-for="post in posts" :key="post._id">{{post.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row m-t-sm">
              <div class="col-xs-12">
                <div class="col-xs-6 p-t-b-sm col-sm-3 text-right">
                  所在部门（院系）:
                </div>
                <div class="col-xs-6 clearfix col-sm-5">
                  <select v-model="parent.selected" class="select input-md col-xs-12 m-b-sm" @change="selectImportParent($event,indexd)" v-for="(parent,indexd) in import_pids" :key="indexd">
                    <option :value="p._id" v-for="p in parent.options" :key="p._id">{{p.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row text-center m-t-b-sm">
              <button class="btn btn-primary m-r-md" @click="importInvitations(0)" :disabled="!import_btn_active">保存</button>
              <button class="btn btn-primary m-r-md" @click="importInvitations(1)" :disabled="!import_btn_active">保存并发送邀请</button>
              <button class="btn btn-default" @click="clearImport()" :disabled="!import_btn_active">取消</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- import  end -->

    <!-- /  semd /-->
    <div v-if="modal.batch">
      <div class="overlay">
      </div>
      <transition name="fade">
        <div class="modal">
          <div class="modal-header">
            {{modal.title}}
            <span class="close" @click="clearBatchInvite()">X</span>
          </div>
          <div class="modal-body w-sm" style="min-height:300px;">
            <div class="row m-t-sm">
              <div class="col-xs-12 p-t-b-sm">
                您一共选择了：
              </div>
              <div class="col-xs-12">
                <div class="p-sm select-invitation-list">
                  <div class="btn btn-sm m-r-xs m-b-xs" v-for="(invite,index) in select_invitations" :key="invite._id" :class="{'btn-primary': index % 5===0,'btn-success': index % 5===1,'btn-info': index % 5===2,'btn-warning': index % 5===3,}"> {{invite.realname}}-{{invite.questionnaire_post.name}}</div>
                </div>
              </div>
              <div class="col-xs-12 p-t-b-sm">
                共 {{select_invitations.length}}人。
              </div>
            </div>
            <div class="row text-center m-t-b-sm">
              <button class="btn btn-primary m-r-md" @click="batchInvitations(1)" :disabled="!batch_invite_btn_active">发送邀请</button>
              <button class="btn btn-default" @click="clearBatchInvite()" :disabled="!batch_invite_btn_active">取消</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- import  end -->

    <!-- /  tag  /-->
    <div v-if="modal.tag">
      <div class="overlay">
      </div>
      <transition name="fade">
        <div class="modal">
          <div class="modal-header">
            标记简历：{{tag_invite.name}}
            <span class="close" @click="closeTagSetting()">X</span>
          </div>
          <div class="modal-body" style="width: 400px;">
            <div class="row m-t-sm text-center">
              <div class="btn btn-sm m-r-sm" :class="{'btn-success': tag_invite.tag === 2}" @click="tag_invite.tag=2">入职</div>
              <div class="btn btn-sm" :class="{'btn-success': tag_invite.tag === 3}" @click="tag_invite.tag=3">不考虑</div>
            </div>
            <div class="m-t-sm" style="border-bottom:1px solid #888;"></div>
            <div class="row m-t-sm">
              <div class="col-xs-6">
                <button class="btn btn-default m-r-sm col-xs-12 col-sm-6 right" @click="closeTagSetting()" :disabled="!batch_invite_btn_active">取消</button>
              </div>
              <div class="col-xs-6">
                <button class="btn btn-primary m-r-md col-xs-12 col-sm-6" @click="saveTag()" :disabled="!batch_invite_btn_active">标记</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- tag  end -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { deepCopy } from "../../../plugins/utils";
import WebUploader from "webuploader";
import User from "../../../resource/user";
import Company from "../../../resource/company";
import Resume from "../../../resource/resume";
import Invitation from "../../../resource/invitation";
import Organization from "../../../resource/organization";
import Post from "../../../resource/post";
import Toast from "../../../plugins/toaster";
import Loading from "../../blocks/loading.vue";
export default {
  components: {
    Loading
  },
  data: function() {
    return {
      loading: 1,
      select_all: 0,
      posts: [],
      invitations: [],
      invitation: {
        realname: "",
        email: "",
        phone: "",
        questionnaire_post: "-1",
        edu_school: "",
        education: 3,
        work_year: 0,
        pids: [
          {
            selected: "-1",
            options: [{ _id: "-1", name: "请选择..." }]
          }
        ]
      }, // 简历
      modal: {
        title: "发送邀请",
        edit: false,
        import: false,
        readonly: false,
        batch: false,
        tag: false
      },
      filter: {
        status: 0,
        tag: 0,
        search: "",
        current: 1,
        length: 20,
        isMy: 0,
        start: 0,
        total: 0,
        questionnaire_post: "-1",
        pids: [
          {
            selected: "-1",
            options: [{ _id: "-1", name: "请选择..." }]
          }
        ]
      },
      import_invitations: [],
      import_questionnaire_post: "-1",
      import_btn_active: true,
      import_pids: [],
      select_invitations: [],
      batch_questionnaire_post: "-1",
      batch_invite_btn_active: true,
      orgs: [],
      view_orgs: {},
      tag_invite: {}
    };
  },
  computed: {
    ...mapGetters({
      user: "loginUser",
      selectPost: "selectPost"
    }),
    company: function() {
      let that = this;
      if (that.user.category === 2) {
        return that.user.user_company;
      } else if (that.user.role === 2 || that.user.role === 3) {
        return that.user.company;
      } else {
        return null;
      }
    }
  },
  created: function() {
    let that = this;
    if (
      that.user.category === 2 ||
      that.user.role === 2 ||
      that.user.role === 3
    ) {
      document.title = `测评邀请-企业控制台|${that.global.name}`;
      that.loadPosts();
      that.loadOrgs();
    } else {
      that.$router.replace("/");
    }
  },
  watch: {
    "filter.tag": function() {
      let that = this;
      that.reload();
    },
    "filter.status": function() {
      let that = this;
      that.reload();
    },
    "filter.isMy": function() {
      let that = this;
      that.reload();
    },
    "filter.questionnaire_post": function() {
      let that = this;
      that.reload();
    }
  },
  methods: {
    loadOrgs: function() {
      let that = this;
      Organization.query({}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            let orgs = data.result || [];
            let _orgs = [];
            that.view_orgs = {};
            orgs.forEach(org => {
              // 自身检查
              let tmp = that.view_orgs[org._id];
              if (!tmp) {
                // 不存在
                tmp = org;
                tmp.children = [];
                tmp.is_opened = 1;
                tmp.is_locked = -1;
                that.view_orgs[org._id] = tmp; // 设置
              } else {
                // 存在
                tmp.name = org.name;
                tmp.pid = org.pid;
                tmp.sort = org.sort;
              }
              if (tmp.pid) {
                //父级检查
                let p = that.view_orgs[org.pid];
                if (!p) {
                  // 不存在
                  p = {
                    _id: org.pid,
                    children: [],
                    is_opened: 1,
                    is_locked: -1
                  };
                  that.view_orgs[org.pid] = p; // 设置
                }
                p.children.push(tmp);
              } else {
                _orgs.push(tmp);
              }
            });
            let sort = function(ogs) {
              ogs.sort((a, b) => {
                return a.sort - b.sort;
              });
              ogs.forEach(og => sort(og.children));
            };
            sort(_orgs);
            that.orgs = _orgs;
            that.filter.pids = [
              {
                selected: "-1",
                options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
              }
            ];
          } else {
            Toast.alert(data.msg);
          }
        },
        res => {}
      );
    },
    selectParent: function(event, indexd) {
      const that = this;
      let val = event.target.value;
      that.filter.pids = that.filter.pids.slice(0, indexd + 1);
      if (val !== "-1") {
        // indexd
        let tmp = that.view_orgs[val];
        if (tmp) {
          if (tmp.children.length > 0) {
            that.filter.pids.push({
              selected: "-1",
              options: [{ _id: "-1", name: "请选择..." }].concat(tmp.children)
            });
          }
        }
      }
    },
    selectIParent: function(event, indexd) {
      const that = this;
      let val = event.target.value;
      that.invitation.pids = that.invitation.pids.slice(0, indexd + 1);
      if (val !== "-1") {
        // indexd
        let tmp = that.view_orgs[val];
        if (tmp) {
          if (tmp.children.length > 0) {
            that.invitation.pids.push({
              selected: "-1",
              options: [{ _id: "-1", name: "请选择..." }].concat(tmp.children)
            });
          }
        }
      }
    },
    selectImportParent: function(event, indexd) {
      const that = this;
      let val = event.target.value;
      that.import_pids = that.import_pids.slice(0, indexd + 1);
      if (val !== "-1") {
        // indexd
        let tmp = that.view_orgs[val];
        if (tmp) {
          if (tmp.children.length > 0) {
            that.import_pids.push({
              selected: "-1",
              options: [{ _id: "-1", name: "请选择..." }].concat(tmp.children)
            });
          }
        }
      }
    },
    loadInvitations: function() {
      let that = this;
      that.filter.start =
        (Number(that.filter.current) - 1) * Number(that.filter.length);
      let query = deepCopy(that.filter);
      if (query.questionnaire_post === "-1") {
        delete query.questionnaire_post;
      }
      let organization = "";
      query.pids.forEach(p => {
        if (p.selected != -1) {
          organization = p.selected;
        }
      });
      delete query.pids;
      if (organization) {
        query.organization = organization;
      }
      Invitation.query(query).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.invitations = data.result.results || [];
            that.filter.total = data.result.count;
            that.select_invitations = [];
            that.select_all = 0;
            that.loading = 0;
          } else {
            Toast.alert(data.msg);
          }
        },
        res => {}
      );
    },
    loadPosts: function() {
      let that = this;
      Post.all({}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.posts = data.result || [];
          } else {
            Toast.alert(data.msg);
          }
        },
        res => {}
      );
    },
    upsert: function() {
      let that = this;
      if (!that.invitation.realname) {
        Toast.alert("请填写姓名");
        return;
      }
      if (
        !that.global.regex.phone.test(that.invitation.phone) &&
        !that.global.regex.email.test(that.invitation.email)
      ) {
        Toast.alert("请填写正确邮箱或者手机号");
        return;
      }
      if (that.invitation.questionnaire_post === "-1") {
        Toast.alert("请选择测评岗位");
        return;
      }
      let resolves = [
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.loadInvitations();
            that.clearEdit();
            Toast.alert("邀请成功");
          } else {
            Toast.alert(data.msg);
          }
        },
        res => {}
      ];
      let invitation = deepCopy(that.invitation);
      invitation.pids.forEach(p => {
        if (p.selected != -1) {
          invitation.organization = p.selected;
        }
      });
      delete invitation.pids;
      if (!invitation.organization) {
        invitation.organization = that.company._id;
      }
      if (that.invitation._id) {
        Invitation.update({ _id: that.invitation._id }, invitation).then(
          ...resolves
        );
      } else {
        Invitation.save({}, invitation).then(...resolves);
      }
    },
    clearEdit: function() {
      // 取消编辑
      let that = this;
      that.modal.edit = false;
      that.modal.readonly = false;
    },
    clearImport: function(type) {
      // 取消倒入
      let that = this;
      if (type !== 1) {
        if (!confirm("您要取消本次数据导入吗？")) {
          return false;
        }
      }
      that.modal.import = false;
      that.import_invitations = [];
      that.import_pids = [];
      that.import_questionnaire_post = "-1";
    },
    add: function() {
      let that = this;
      that.invitation = {
        realname: "",
        email: "",
        phone: "",
        questionnaire_post: "-1",
        edu_school: "",
        education: 3,
        work_year: 0,
        pids: [
          {
            selected: "-1",
            options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
          }
        ]
      };
      that.modal.title = "发送邀请";
      that.modal.edit = true;
    },
    edit: function(invitation) {
      let that = this;
      for (let prop in that.invitation) {
        that.invitation[prop] = invitation[prop];
      }
      that.invitation._id = invitation._id;
      that.invitation.questionnaire_post = invitation.questionnaire_post._id;
      that.modal.title = "修改邀请信息";
      that.modal.edit = true;
    },
    show: function(invitation) {
      let that = this;
      for (let prop in that.invitation) {
        that.invitation[prop] = invitation[prop];
      }
      that.invitation._id = invitation._id;
      that.invitation.questionnaire_post =
        (invitation.questionnaire_post && invitation.questionnaire_post._id) ||
        "-1";
      let pids = [];
      let recursion = function(_id, pid) {
        // 向前追溯
        if (!pid) {
          pids.unshift({
            selected: _id,
            options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
          });
        } else {
          let p1 = that.view_orgs[pid]; // 父级
          pids.unshift({
            selected: _id,
            options: [{ _id: "-1", name: "请选择..." }].concat(p1.children)
          });
          recursion(p1._id, p1.pid);
        }
      };
      if (invitation.organization) {
        let p = that.view_orgs[invitation.organization._id];
        recursion(p._id, p.pid);
      } else {
        pids.push({
          selected: "-1",
          options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
        });
      }
      that.invitation.pids = pids;
      that.modal.title = "查看邀请信息";
      that.modal.edit = true;
      that.modal.readonly = true;
    },
    reload: function() {
      let that = this;
      that.go(1);
    },
    go: function(page) {
      let that = this;
      that.filter.current = page;
      that.loadInvitations();
    },
    importInvitations: function(type) {
      let that = this;
      that.import_btn_active = false;
      let options = {
        invitations: that.import_invitations,
        invite: 0
      };
      if (that.import_questionnaire_post === "-1") {
        that.import_btn_active = true;
        Toast.alert("请选择测评岗位");
        return;
      }
      options.questionnaire_post = that.import_questionnaire_post;
      if (type === 1) {
        options.invite = 1;
      }
      that.import_pids.forEach(p => {
        if (p.selected != -1) {
          options.organization = p.selected;
        }
      });
      if (!options.organization) {
        options.organization = that.company._id;
      }
      Invitation.importInvitations({}, options).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            if (data.result.err && data.result.err.length > 0) {
              Toast.alert(data.result.err.join(""));
            }
            that.loadInvitations();
          } else {
            Toast.alert(data.msg);
          }
          that.clearImport(1);
          that.import_btn_active = true;
        },
        res => {
          that.clearImport(1);
          that.import_btn_active = true;
        }
      );
    },
    toggleSelectAll: function() {
      let that = this;
      let tmp = that.invitations.filter(
        invitation => invitation.status === 1 || invitation.status === -2
      );
      if (that.select_all === 0) {
        that.select_invitations = [];
      } else {
        that.select_invitations = tmp;
      }
      tmp.forEach(invitation => {
        invitation.selected = that.select_all;
      });
    },
    batchInvites: function(post) {
      let that = this;
      if (that.select_invitations.length === 0) {
        Toast.alert("请选择邀请人");
      } else {
        that.modal.batch = true;
        that.batch_questionnaire_post = post || "-1";
      }
    },
    toggleSelectNode: function(invitation) {
      let that = this;
      that.select_invitations = that.invitations.filter(
        inv => inv.selected === 1
      );
      if (invitation.selected === 0) {
        that.select_all = 0;
      } else {
        let tmp = that.invitations.filter(inv => {
          return inv.selected === 1 || inv.status === -2;
        });
        if (tmp.length === that.select_invitations.length) {
          that.select_all = 1;
        }
      }
    },
    invite: function(invitation) {
      let that = this;
      invitation.selected = 1;
      that.select_invitations = [invitation];
      that.toggleSelectNode(invitation);
      that.batchInvites(invitation.questionnaire_post || "-1");
    },
    clearBatchInvite: function(type) {
      let that = this;
      if (type !== 1) {
        if (!confirm("您要取消本次邀请操作嘛？")) {
          return false;
        }
      }
      that.modal.batch = false;
      that.select_invitations.forEach(inv => {
        inv.selected = 0;
      });
      that.select_invitations = [];
      that.select_all = 0;
      that.batch_questionnaire_post = "-1";
    },
    batchInvitations: function() {
      let that = this;
      that.batch_invite_btn_active = false;
      let options = {
        invitations: that.select_invitations.map(invitation => ({
          id: invitation._id,
          email: invitation.email
        }))
      };
      Invitation.batchInvitations({}, options).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            if (data.result.err && data.result.err.length > 0) {
              const errMsgs = data.result.err.reduce((pre, cur) => {
                for (let p in cur) {
                  pre.push(`${p}:${cur[p]};\n`);
                }
                return pre;
              }, []);
              Toast.alert(errMsgs.join(""));
            } else {
              Toast.alert("邀请成功");
            }
            that.loadInvitations();
          } else {
            Toast.alert(data.msg);
          }
          that.clearBatchInvite(1);
          that.batch_invite_btn_active = true;
        },
        res => {
          that.clearBatchInvite(1);
          that.batch_invite_btn_active = true;
        }
      );
    },
    tagInivite: function(invite) {
      const that = this;
      that.tag_invite = {
        _id: invite._id,
        tag: invite.tag,
        name: invite.realname,
        invite
      };
      that.modal.tag = true;
    },
    closeTagSetting: function() {
      const that = this;
      if (confirm("您要取消本次操作吗？")) {
        that.modal.tag = false;
      }
    },
    saveTag: function() {
      const that = this;
      if (that.tag_invite.tag !== 1) {
        Invitation.tag(
          { _id: that.tag_invite._id },
          { tag: that.tag_invite.tag }
        ).then(res => {
          let data = res.body;
          if (data.code === 0) {
            alert("标记成功");
            that.modal.tag = false;
            that.tag_invite.invite.tag = that.tag_invite.tag;
          } else {
            alert(data.msg);
          }
        });
      } else {
        alert("请先标记面试者状态");
      }
    },
    addCompareResume: function(report) {
      const that = this;
      that.$store.dispatch("addCompareResume", {
        code: report.evaluate_record.record,
        user: { realname: report.realname, phone: report.phone },
        post: report.questionnaire_post.alias,
        post_id: report.questionnaire_post._id,
        score: report.score.toFixed(2)
      });
    }
  },
  mounted: function() {
    let that = this;
    that.loadInvitations(); // 载入简历
    let uploader = WebUploader.create({
      auto: true,
      server: "/api/upload_xlsx",
      pick: {
        id: "#upload-resume-btn",
        innerHTML: "",
        multiple: false
      },
      formData: {}
    });
    uploader.on("beforeFileQueued", file => {
      if (!file.name.endsWith(".xls") && !file.name.endsWith(".xlsx")) {
        Toast.alert("请选择excel文件后再进行上传");
        return false;
      } else {
        return true;
      }
    });
    uploader.on("uploadSuccess", (file, res) => {
      if (res.code === 0) {
        uploader.reset();
        that.modal.title = "导入邀请";
        that.import_invitations = res.result.reduce((rs, val) => {
          if (val) {
            let realname = val["姓名"];
            let email = val["邮箱"];
            let phone = val["手机号"];
            if (
              realname &&
              (that.global.regex.email.test(email) ||
                that.global.regex.phone.test(phone))
            ) {
              rs.push({ realname, phone, email });
            }
          }
          return rs;
        }, []);
        that.import_pids = [
          {
            selected: "-1",
            options: [{ _id: "-1", name: "请选择..." }].concat(that.orgs)
          }
        ];
        that.modal.import = that.import_invitations.length > 0;
        if (!that.modal.import) {
          Toast.alert("您上传的数据中无符合条件数据");
        }
      } else {
        Toast.alert(res.msg);
      }
    });
  }
};
</script>
<style lang="less" scoped>
.invitate-code {
  padding-left: 15px;
  padding-right: 15px;
  &.code_is_active {
    color: #42b983;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.select-invitation-list {
  border: 1px solid #e8e8e8;
  background-color: #eee;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// list.vue?ebec4080